import React, { forwardRef, MutableRefObject, ReactNode } from 'react';
import classNames from 'classnames';
import styles from './Content.module.scss';
import { ContentErrorBoundary } from '@views/ErrorBoundary';
import Header, { HeaderProps } from '../Header';

interface CustomContentProps {
  header?: ReactNode;
  headerProps?: HeaderProps;
  headerClassName?: string;
}

export type ContentProps = React.ComponentPropsWithoutRef<'div'> & CustomContentProps;

export const SidebarContent = ({ className, children }) => (
  <ContentErrorBoundary>
    <div className={classNames('content', className, styles.container)}>{children}</div>
  </ContentErrorBoundary>
);

function Content(
  {
    children = null,
    className = null,
    header = null,
    headerProps = {},
    headerClassName = null,
    ...props
  }: ContentProps,
  ref: MutableRefObject<HTMLDivElement>,
) {
  return (
    <ContentErrorBoundary>
      <div
        tabIndex={1}
        className={classNames('content', className, styles.container)}
        id="content"
        {...props}
        ref={ref}
      >
        <div className={styles.header}>
          {header ? header : <Header {...headerProps} className={headerClassName} />}
        </div>
        {children}
      </div>
    </ContentErrorBoundary>
  );
}

export default forwardRef(Content);
